import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormatDateService {
  constructor() {}
  parseDateParts(value: any): { year: number; month: number; day: number } | null {
    if (!value) return null;
    if (typeof value === 'string') {
      const trimmed = value.trim();
      const isoMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (isoMatch) {
        return {
          year: parseInt(isoMatch[1], 10),
          month: parseInt(isoMatch[2], 10) - 1,
          day: parseInt(isoMatch[3], 10),
        };
      }
      const dmyMatch = trimmed.match(/^(\d{2})[-/](\d{2})[-/](\d{4})/);
      if (dmyMatch) {
        return {
          year: parseInt(dmyMatch[3], 10),
          month: parseInt(dmyMatch[2], 10) - 1,
          day: parseInt(dmyMatch[1], 10),
        };
      }
    }
    const d = new Date(value);
    if (isNaN(d.getTime())) return null;
    return {
      year: d.getUTCFullYear(),
      month: d.getUTCMonth(),
      day: d.getUTCDate(),
    };
  }

  formatDisplayDate(value: any): string {
    if (!value) return '';

    const parts = this.parseDateParts(value);
    if (!parts) return '';

    const utcDate = new Date(Date.UTC(parts.year, parts.month, parts.day));
    const formatted = utcDate.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      timeZone: 'UTC',
    });

    const [day, month, year] = formatted.split(' ');

    return `${day} ${month},${year}`;
  }
}
